export const config = {
  apiBaseUrl: 'https://yokeojbh71.execute-api.us-east-1.amazonaws.com/test',
  stripePublicKey:
    'pk_test_51S0YrRLFv62eRi6FcbfWlVQrhngssWcH7n0HAMPdbYJKpyROSM8REeAxrrh6JxQrV91hvqOXma98yeRkUI6mceoX00ulvinGvD',
  environment: 'test',
};
